import { useAuth } from '../../context/AuthContext';
import { formatDateTime } from '../../utils/formatDate';

export default function Profile() {
  const { user } = useAuth();

  return (
    <div>
      <div className="mb-6">
        <div className="text-[11px] text-[#475569] mb-[2px]">Account</div>
        <div className="flex items-center gap-5 mt-3">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#06b6d4] to-[#818cf8] flex items-center justify-center text-white text-xl font-bold">
            {user?.name?.charAt(0) || 'U'}
          </div>
          <div>
            <h1 className="text-[22px] font-bold text-[#e2e8f0]">{user?.name}</h1>
            <p className="text-[13px] text-[#64748b]">{user?.organization?.name}</p>
          </div>
        </div>
      </div>

      <div className="max-w-2xl space-y-4">
        <div className="bg-[#0f1623] border border-[rgba(148,163,184,0.06)] rounded-[10px] p-6">
          <h3 className="text-[14px] font-semibold text-[#e2e8f0] mb-4">Account Information</h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-[10px] text-[#475569] uppercase tracking-wider">Name</p>
              <p className="text-[13px] text-[#e2e8f0] mt-1">{user?.name}</p>
            </div>
            <div>
              <p className="text-[10px] text-[#475569] uppercase tracking-wider">Email</p>
              <p className="text-[13px] text-[#e2e8f0] mt-1">{user?.email}</p>
            </div>
            <div>
              <p className="text-[10px] text-[#475569] uppercase tracking-wider">Role</p>
              <p className="text-[13px] text-[#e2e8f0] mt-1 capitalize">{user?.role?.replace('_', ' ')}</p>
            </div>
            <div>
              <p className="text-[10px] text-[#475569] uppercase tracking-wider">Last Login</p>
              <p className="text-[13px] text-[#e2e8f0] mt-1">{formatDateTime(user?.lastLogin)}</p>
            </div>
          </div>
        </div>

        <div className="bg-[#0f1623] border border-[rgba(148,163,184,0.06)] rounded-[10px] p-6">
          <h3 className="text-[14px] font-semibold text-[#e2e8f0] mb-4">Organization</h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-[10px] text-[#475569] uppercase tracking-wider">Organization</p>
              <p className="text-[13px] text-[#e2e8f0] mt-1">{user?.organization?.name}</p>
            </div>
            <div>
              <p className="text-[10px] text-[#475569] uppercase tracking-wider">Short Name</p>
              <p className="text-[13px] text-[#e2e8f0] mt-1">{user?.organization?.shortName || '—'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
